export interface User {
  idUsuario: string;
  email: string;
  idEmpleado?: number;
}

export interface AuthMeResponse {
  data: {
    uid: string;
    email: string;
    role: string;
    id_empleado?: number;
    nombre?: string;
  };
}

export const UserRoles = {
  HR_ADMIN: 'HR_ADMIN',
  OPS_ADMIN: 'OPS_ADMIN',
  EMPLOYEE_SELF: 'EMPLOYEE_SELF',
} as const;

export type UserRole = (typeof UserRoles)[keyof typeof UserRoles];

export const VALID_ROLES: readonly UserRole[] = Object.values(UserRoles);

export interface Profile {
  rol: UserRole;
}

export enum SessionKeys {
  USER = 'app_user',
  PROFILE = 'app_profile',
}

export enum StorageType {
  LOCAL = 'local',
  SESSION = 'session',
}
